import { render, staticRenderFns } from "./CourseTask.vue?vue&type=template&id=0ded41c8&scoped=true&"
import script from "./CourseTask.vue?vue&type=script&lang=js&"
export * from "./CourseTask.vue?vue&type=script&lang=js&"
import style0 from "./CourseTask.vue?vue&type=style&index=0&id=0ded41c8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ded41c8",
  null
  
)

export default component.exports